import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const SettingsGearIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                d="M18.544 8.046a1.547 1.547 0 0 0 .88 2.123l1.045.372a1.549 1.549 0 0 1 0 2.92l-1.045.371a1.547 1.547 0 0 0-.88 2.124l.478 1a1.55 1.55 0 0 1-2.066 2.066l-1.002-.476a1.547 1.547 0 0 0-2.123.88l-.372 1.045a1.55 1.55 0 0 1-2.919 0l-.372-1.045a1.551 1.551 0 0 0-2.124-.88l-1 .476a1.548 1.548 0 0 1-2.066-2.066l.476-1.002a1.548 1.548 0 0 0-.88-2.123l-1.045-.372a1.549 1.549 0 0 1 0-2.92l1.045-.371a1.547 1.547 0 0 0 .88-2.122l-.476-1.002a1.548 1.548 0 0 1 2.065-2.066l1.002.476a1.549 1.549 0 0 0 2.123-.878l.372-1.045a1.549 1.549 0 0 1 2.919 0l.372 1.045a1.548 1.548 0 0 0 2.123.88l1.002-.478a1.55 1.55 0 0 1 2.066 2.066l-.478 1.002Z"
            />
            <path stroke="currentColor" d="M8.499 12.001a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0Z" />
        </svg>
    </IconWrapper>
)
